export enum RoleTypesEnum {
  ADMIN = "admin",
  SUB_ADMIN = "sub-admin",
  CLIENT = "client",
  DISTRIBUTOR = "distributor",
  SALES_TEAM = "sales",
  ACCOUNTS = "accounts",
  PRODUCTION_MANAGER = "production-manager",
  PRODUCTION_TEAM = "production-team",
  DISPATCH_MANAGER = "dispatch-manager",
  DISPATCH_TEAM = "dispatch-team",
  INSTALLATION_MANAGER = "installation-manager",
  INSTALLATION_TEAM = "installation-team",
  DESIGN_TEAM = "design-team",
  SALES_MANAGER = "sales-manager",
  CREDIT_CONTROLLER = "credit-controller",
  PRINTING_MANAGER = "printing-manager",
  SEO = "seo",
  STORE_EXECUTIVE = "store-executive",
}

export enum DashboardTypeEnum {
  ALL = "all", // For Admin/Sub-Admin with access to all dashboards
  ADMIN = "admin_dashboard",
  FINANCE = "finance_dashboard",
  SALES = "sales_dashboard",
  PRODUCTION = "production_dashboard",
  INSTALLATION = "installation_dashboard",
  DISPATCH = "dispatch_dashboard",
  CUSTOMER = "customer_dashboard",
  HR = "hr_dashboard",
  PRINTING_MANAGER = "printing_manager_dashboard",
}

export const DashboardTypeLabels: Record<DashboardTypeEnum, string> = {
  [DashboardTypeEnum.ALL]: "All Dashboard",
  [DashboardTypeEnum.ADMIN]: "Admin Dashboard",
  [DashboardTypeEnum.FINANCE]: "Finance Dashboard",
  [DashboardTypeEnum.SALES]: "Sales Dashboard",
  [DashboardTypeEnum.PRODUCTION]: "Production Dashboard",
  [DashboardTypeEnum.INSTALLATION]: "Installation Dashboard",
  [DashboardTypeEnum.DISPATCH]: "Dispatch Dashboard",
  [DashboardTypeEnum.CUSTOMER]: "Customer Dashboard",
  [DashboardTypeEnum.HR]: "HR Dashboard",
  [DashboardTypeEnum.PRINTING_MANAGER]: "Printing Manager Dashboard",
};

export const getDashboardOptions = (isCustomer: boolean = false) =>
  Object.values(DashboardTypeEnum).map((opt) => {
    if (opt === DashboardTypeEnum.CUSTOMER && !isCustomer) {
      return { label: DashboardTypeLabels[opt], value: opt, disabled: true };
    }
    return { label: DashboardTypeLabels[opt], value: opt, disabled: false };
  });
